var RedactionShapeModel = require('../redaction'),
    CodeBoxModel = require('./codeBox'),
    ConnectionModel = require('./connection'),
    ShapeUtils = require('../../../shapeUtils');


module.exports = RedactionShapeModel.extend({

    /**
     * isBoxDirty
     * - now only require for Find and Redact
     * - true if codes changed, box moved, box resized
     * Must to be in constructor, not initialize, b/c of sub shapes
     * Obvious candidate for Find and Redact sub-classing
     */
    constructor: function() {

        this.isBoxDirty = false;
        RedactionShapeModel.prototype.constructor.apply( this, arguments );

    },
    /*
    * seeThroughFillOpacity:
    *   - Write just in case; not applicable to FDD zone redactions since this value can't be stored.
    *   - Now no option exist for user to change it
    *   - Should store this on shape, not note model
    *   - Read in but never applied ... with current infrastructure (need to move color attrs to shapes )
    * */
    defaults: function() {

        return _.extend( {} , RedactionShapeModel.prototype.defaults.apply(this, arguments), {
            box: null,
            connection: null,
            seeThroughFillOpacity: this.parentNote.getDefaultFillOpacity()
        });

    },

    /**
     * seeThroughFillOpacity is read in but never applied; any value is ignored for the default; would need to change arch for that.
     * options.onlySetBoxAndConnection: another temporary F&R POC
     */
    parse: function( attrs, options ) {

        if ( options && !options.onlySetBoxAndConnection )
        {
            attrs = RedactionShapeModel.prototype.parse.apply(this, arguments);
        }

        attrs.box &&
            ( this.box = new CodeBoxModel( attrs.box) );

        attrs.connection &&
            ( this.connection = new ConnectionModel( attrs.connection ) );

        return _.omit(attrs, 'box', 'connection');
    },

    /*
    * Augment the base with box, connection, and seeThroughFillOpacity.
    * */
    getAttrsToPersist: function( scale ) {

        /*
        * While blocked in the UI, emphasize that this model will never on exist on COLD pages,
        * and that we don't need to include calculations for that page type here.
        * If this ever changes, will need to adjust code accordingly.
        * */
        if ( this.pageModel.isCold() )
            return;


        /*
         * seeThroughFillOpacity:
         * - doesn't apply to the base coordinate shape so apply here whether there are reason codes applied / not.
         * - need to change arch to use this.get('seeThroughFillOpacity') ... this would not necessarily be correct ( but for now should never change )
         */
        var attrs = _.extend( {}, RedactionShapeModel.prototype.getAttrsToPersist.apply(this, arguments) , {
                box: null,
                connection: null,
                seeThroughFillOpacity: this.parentNote.getDefaultFillOpacity()
            }),
            reasonCodesCollection = this.getReasonCodeCollection();


        if (reasonCodesCollection.length < 1)
            return attrs;

        /*
        * It has reason codes, get the box and connection from the 'controller' stored on the parent note model;
        * Use attributes stored (that could later be changed) from that on the box and connection models,
        * except for the points: get them from the actual Raphael el's like doing for all other shapes.
        * ( Alternative would be updating the coordinates of each on every change ).
        * */
        var floatingCodesController = this.parentNote.floatingCodesController,
            uniqueCodeStr = reasonCodesCollection.getCodesAsString(),
            codesView = floatingCodesController.getCodeViewOfUniqueCodeString( uniqueCodeStr ),
            shapeView = floatingCodesController.getShapeViewByShapeModel(this),
            connectionLine = shapeView.connection.line,
            codeUIModel = codesView.model,
            boxModelAttrs = codeUIModel.getBoxModel().toJSON(),
            connectionModelAttrs = codeUIModel.getConnectionModel().toJSON();

        boxModelAttrs.points =
            ShapeUtils.adjustPtsFromViewerToDbNoTransform( codesView.el.getPathCoordinates(), this.pageModel.getDPI() );

        // Note: use the 'old' method for the connection pts (it doesn't have transforms applied )
        connectionModelAttrs.points =
            this._getPointsFromEl( scale, connectionLine.getPathCoordinates() );

        _.extend( attrs, {
            box:  boxModelAttrs,
            connection: connectionModelAttrs
        });

        return attrs;

    },

    /*
    * Could also point on the box but this is working and simpler.
    * If start using other shape typea that don't do transforms, will prob want a mixin, util fn for them.
    * TODO: these type of redactions are now not supported on COLD pages
    * */
    getAdjustedBoxPts: function() {

        return this.pageModel.isCold()
            ? RedactionShapeModel.prototype._getColdPageAdjustedPointsArray(1) // just call the original with a scale of 1 ( no transform) TODO: test
            : ShapeUtils.adjustPtsFromDbToViewerWithoutTransform( this.getBox().getPoints() , this.pageModel.getDPI() );

    },

    getBox: function() {
        return this.box;
    },
    getConnection: function() {
        return this.connection;
    },

    /**
     * POC -- Used for Find and Redact.
     * ( Another candidate for shape sub-classing ).
     * Now only used for floating codes -- --- may prove helpful for other shapes (if we allow to move points, eg )
     * Remember on page change, save if not from hidden canvas -- so the box can be positioned correctly on re-entry.
     * Set the saved attributes on the now contrived shape model.
     * Some may be redundant if we save as we go -- ! at least we need box ( and connection ?) !
     */
    updateShapeAttributes: function( scale ) {

        var attrsToSave =  this.getAttrsToPersist( scale ); // points not taken from el

        this.set( attrsToSave, {silent: true} ); // ( Silent just in case )

        // Setting the attributes isn't enough -- the box, connection attributes must to be set
        // to create the box and connection objects -- which aren't attributes but instance variables; these are set on parse
        // I suppose only really need to update the box and the connection -- now we don't need the points
        this.parse( this.attributes, {
            onlySetBoxAndConnection: 1
        } );

    },

    /* Now only used for Find and Redact */
    setBoxIsDirty: function( isDirty ) {
        this.isBoxDirty = isDirty;
    },

    getBoxIsDirty: function() {
        return this.isBoxDirty;
    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/floating/shapeModel.js
 ** module id = 258
 ** module chunks = 0
 **/